import styled from 'styled-components';

import CircularProgress from '@mui/material/CircularProgress';

const ProgressContainer = styled.div`
  display: grid;
  place-items: center;
  height: 100px;
  width: 100%;
`;

const Loader = () => {
  return (
    <ProgressContainer>
      <CircularProgress />
    </ProgressContainer>
  );
};

export default Loader;
